// extracted by mini-css-extract-plugin
export default {"container":"PatientImportantInformationsItem_container__6Qvc-","label":"PatientImportantInformationsItem_label__1FOR3","value":"PatientImportantInformationsItem_value__wvnpx"};